import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

const EmployeeDashboard = () => {
  return (
    <div className="space-y-8">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Welcome back, Samuel!</h1>
          <p className="text-gray-500">Here is a quick overview of your employee profile and tasks.</p>
        </div>
        <div className="flex gap-3">
          <button className="bg-[#11469A] text-white px-5 py-2.5 rounded-lg font-bold text-sm shadow-sm hover:bg-[#0d3678] transition-all flex items-center gap-2">
            <SafeIcon name="Calendar" size={18} /> Request Leave
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="card p-5 border-l-4 border-l-[#11469A]">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Leave Balance</p>
          <p className="text-2xl font-bold text-gray-800">14 Days</p>
          <p className="text-xs text-gray-500 mt-1 font-medium">Annual Leave remaining</p>
        </div>
        <div className="card p-5 border-l-4 border-l-green-500">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Next Review</p>
          <p className="text-2xl font-bold text-gray-800">Nov 15</p>
          <p className="text-xs text-gray-500 mt-1 font-medium">Performance Appraisal</p>
        </div>
        <div className="card p-5 border-l-4 border-l-purple-500">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Training</p>
          <p className="text-2xl font-bold text-gray-800">2 Pending</p>
          <p className="text-xs text-gray-500 mt-1 font-medium">Mandatory courses</p>
        </div>
        <div className="card p-5 border-l-4 border-l-yellow-500">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Upcoming Holiday</p>
          <p className="text-2xl font-bold text-gray-800">Dec 1</p>
          <p className="text-xs text-gray-500 mt-1 font-medium">Farmer's Day</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card p-6 border border-gray-100 shadow-sm">
          <h3 className="font-bold text-gray-800 mb-4 flex items-center gap-2">
            <SafeIcon name="Bell" size={18} className="text-[#00AEEF]" /> Recent Announcements
          </h3>
          <div className="space-y-4">
            <div className="p-4 bg-blue-50/50 rounded-lg border border-blue-100">
              <h4 className="font-bold text-[#11469A] text-sm mb-1">End of Year Townhall</h4>
              <p className="text-xs text-gray-600 leading-relaxed">Join us on Dec 15th for the annual company review and awards ceremony. Calendar invites have been sent.</p>
              <p className="text-[10px] text-gray-400 mt-2 font-bold uppercase tracking-wider">Posted 2 days ago</p>
            </div>
            <div className="p-4 bg-gray-50 rounded-lg border border-gray-100">
              <h4 className="font-bold text-gray-800 text-sm mb-1">Updated Health Insurance Policy</h4>
              <p className="text-xs text-gray-600 leading-relaxed">The new HMO documentation is available in the Benefits portal. Please review the updated clinic network.</p>
              <p className="text-[10px] text-gray-400 mt-2 font-bold uppercase tracking-wider">Posted 1 week ago</p>
            </div>
          </div>
        </div>

        <div className="card p-6 border border-gray-100 shadow-sm">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-bold text-gray-800 flex items-center gap-2">
              <SafeIcon name="FileText" size={18} className="text-[#00AEEF]" /> My Tasks & Approvals
            </h3>
          </div>
          <div className="flex flex-col items-center justify-center py-10 text-center">
            <div className="w-16 h-16 bg-green-50 text-green-500 rounded-full flex items-center justify-center mb-4">
              <SafeIcon name="CheckCircle" size={32} />
            </div>
            <p className="font-bold text-gray-800">You're all caught up!</p>
            <p className="text-sm text-gray-500 mt-1">No pending tasks or approvals require your attention.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeDashboard;